export function Terms() {
  return (
    <div className="relative z-10 min-h-screen pt-48 md:pt-56 pb-24 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-sentient font-bold mb-8 leading-tight">
          Terms of <i className="font-light">Service</i>
        </h1>
        
        <div className="space-y-8 font-mono text-foreground/80 leading-relaxed">
          <section>
            <h2 className="text-2xl font-sentient font-semibold mb-4 text-foreground">1. Acceptance of Terms</h2>
            <p className="mb-4">
              By accessing and using Quoril's services, you accept and agree to be bound by the terms and provision of this agreement.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-sentient font-semibold mb-4 text-foreground">2. Use License</h2>
            <p className="mb-4">
              Permission is granted to temporarily access Quoril's services for personal, non-commercial use only. This is the grant of a license, not a transfer of title.
            </p>
            <p className="mb-2">Under this license you may not:</p>
            <ul className="list-disc list-inside ml-4 space-y-2">
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose</li>
              <li>Attempt to decompile or reverse engineer any software</li>
              <li>Remove any copyright or proprietary notations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-sentient font-semibold mb-4 text-foreground">3. User Data</h2>
            <p className="mb-4">
              You retain all rights to any data you submit or upload to Quoril. By using our services, you grant us permission to use this data solely for the purpose of providing our services to you.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-sentient font-semibold mb-4 text-foreground">4. Disclaimer</h2>
            <p className="mb-4">
              The materials on Quoril's services are provided on an 'as is' basis. Quoril makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-sentient font-semibold mb-4 text-foreground">5. Limitations</h2>
            <p className="mb-4">
              In no event shall Quoril or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use Quoril's services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-sentient font-semibold mb-4 text-foreground">6. Modifications</h2>
            <p className="mb-4">
              Quoril may revise these terms of service at any time without notice. By using this service you are agreeing to be bound by the then current version of these terms of service.
            </p>
          </section>

         

          <p className="text-sm text-foreground/60 mt-12">
            Last updated: December 6, 2025
          </p>
        </div>
      </div>
    </div>
  );
}

